export default "__VITE_ASSET__i3BCYkdk__"